"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var awsui_table_page_size_selector_1 = require("./awsui-table-page-size-selector");
var CardsPageSizeSelectorWrapper = /** @class */ (function (_super) {
    __extends(CardsPageSizeSelectorWrapper, _super);
    function CardsPageSizeSelectorWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CardsPageSizeSelectorWrapper;
}(awsui_table_page_size_selector_1.BaseCollectionPageSizeSelectorWrapper));
exports.default = CardsPageSizeSelectorWrapper;
//# sourceMappingURL=awsui-cards-page-size-selector.js.map